import Model, { belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { Currency } from 'lumen/models';

export default class FavouriteCurrency extends Model {
  [Type] = 'favourite-currency' as const;

  @belongsTo('currency', { async: false, inverse: 'favourite' })
  declare currency: Currency;
}
